import axios, { AxiosRequestConfig } from 'axios';
import { useUserStore } from '../../store/userStore';
import { API_URL } from '../../utils/api';

export const AXIOS_INSTANCE = axios.create({
  baseURL: API_URL,
});

AXIOS_INSTANCE.interceptors.request.use((config) => {
  const token = useUserStore.getState().token;
  if (token) {
    config.headers = config.headers || {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }
  return config;
});

AXIOS_INSTANCE.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      const store = useUserStore.getState();
      // Истёк вход от имени (он живёт час) — назад в сессию админа, а не на страницу входа.
      if (store.adminSession) {
        void store.stopImpersonating();
      } else {
        if (typeof store.logout === 'function') store.logout({ isSessionRejected: true });
        if (typeof window !== 'undefined') window.location.href = '/auth/login';
      }
    }
    return Promise.reject(e);
  },
);

// orval generates calls with (url, { ...fetchOptions, method, headers, body })
// We bridge fetch-style (RequestInit) to axios-style (AxiosRequestConfig)
export const customAxios = <T>(
  url: string,
  config?: RequestInit & { params?: unknown },
): Promise<T> => {
  const source = axios.CancelToken.source();
  const c = (config ?? {}) as Record<string, unknown>;
  const axiosConfig: AxiosRequestConfig = {
    url,
    method: c['method'] as string,
    headers: c['headers'] as AxiosRequestConfig['headers'],
    // orval uses `body` (fetch-style) — map to axios `data`
    data: c['body'] !== undefined ? c['body'] : c['data'],
    params: c['params'],
    signal: c['signal'] as AxiosRequestConfig['signal'],
    cancelToken: source.token,
  };
  const promise = AXIOS_INSTANCE(axiosConfig).then((r) => r.data);
  (promise as Promise<T> & { cancel?: () => void }).cancel = () =>
    source.cancel('Query was cancelled');
  return promise as Promise<T>;
};

export default customAxios;
